export const INTRO_STEP = 'intro_step';
export const SUCCESS_STEP = 'success_step';

export const PERPAY_PLUS_STEPS = [INTRO_STEP, SUCCESS_STEP];
